import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { PaymentsEditor } from '../../../components/profileEditors/PaymentsEditor';

const PaymentsStep = ({ provider, setProvider, onNext, onBack, onSkip }) => {
  return (
    <Box sx={{ maxWidth: '600px', margin: '0 auto' }}>
      <Typography variant="h4" sx={{ marginBottom: '20px' }}>
        Payment Setup
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ marginBottom: '24px' }}>
        Choose how clients can pay you. You can set this up now or skip and do it later.
      </Typography>

      {/* Payments editor */}
      <Box sx={{ marginBottom: '30px' }}>
        <PaymentsEditor provider={provider} setProvider={setProvider} />
      </Box>

      {/* Bottom navigation */}
      <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '40px' }}>
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
        <Box sx={{ display: 'flex', gap: '10px' }}>
          <Button variant="text" onClick={onSkip}>
            Skip For Now
          </Button>
          <Button variant="contained" onClick={onNext}>
            Save & Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

PaymentsStep.propTypes = {
  provider: PropTypes.object.isRequired,
  setProvider: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired
};

export default PaymentsStep;
